define('AwaLabs.GoogleTagManagerGA4.Shopping',
    [
        'LiveOrder.Model',
        'Cart.Detailed.View',
        'GoogleTagManager',
        'Tracker',
        'SC.Configuration',
        'jQuery',
        'underscore'
    ],
    function AwaLabsGoogleTagManagerExtras(
        LiveOrderModel,
        CartDetailedView,
        GoogleTagManager,
        Tracker,
        Configuration,
        jQuery,
        _
    ) {

        // Add items to the view cart event
        CartDetailedView.prototype.beforeShowContent = function() {
            var self = this;
            return LiveOrderModel.loadCart().done(function() {
                Tracker.getInstance().trackPageviewForCart({
                    url: '/' + Backbone.history.getFragment(),
                    items: self.model.get('lines'),
                    total: self.model.get('lines').length
                });
            });
        };

        // Add remove item event
        CartDetailedView.prototype.removeItem = _.wrap(CartDetailedView.prototype.removeItem, function wrapRemoveItem(fn) {
            var e;
            var product;
            var self = this;
            var removePromise = fn.apply(this, _.toArray(arguments).slice(1));
            try {
                e = _.toArray(arguments).slice(1)[0];
                product = this.model.get('lines').get(this.$(e.target).data('internalid'));
                GoogleTagManager.trackRemoveFromCart(product, this.model);
            } catch (err) {
                return err;
            }

            removePromise.always(function alwaysRemove() {
                GoogleTagManager.trackPageviewForCart({
                    url: '/cart',
                    items: self.model.get('lines'),
                    total: self.model.get('lines').length
                });
            });
            return removePromise;
        });

        _.extend(GoogleTagManager, {
            trackRemoveFromCart: function trackRemoveFromCart(line) {
                var item = line.get('item');
                var eventName = 'remove_from_cart';
                var eventData = {
                    'event': eventName,
                    ecommerce: {
                        remove_from_cart: {
                            actionField: {
                                currency: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl || 'USD',
                                revenue: line.get('amount'),
                                products: [{
                                    id: item.get('itemid'),
                                    sku: item.get('itemid'),
                                    internalid: item.get('internalid'),
                                    name: item.get('_name'),
                                    price: item.get('_priceDetails').onlinecustomerprice,
                                    quantity: line.get('quantity')
                                }]
                            }
                        }
                    }
                };
                Tracker.trigger(eventName, eventData, line);
                this.pushData(eventData);
                return this;
            }
        });

        return {
            mountToApp: function mountToApp(application) {
                var Layout = application.getLayout();
                var urlParameters;

                Layout.on('afterAppendView', function afterAppendView(){
                    urlParameters = _.parseUrlOptions(Backbone.history.fragment);
                    if(urlParameters && urlParameters.keywords){
                        GoogleTagManager.trackSearchResults([], urlParameters.keywords);
                    }
                });
            }
        };
    });
